import { getPageUrlDic, Page } from './routes';

const FARM_UUID_TOKEN = '__FARM_UUID__';

const pageUrlDic = getPageUrlDic({ prefix: '', farmUuid: FARM_UUID_TOKEN });

const BIOENERGY_PATH_SUFFIX =
  pageUrlDic[Page.BIOENERGY].split(FARM_UUID_TOKEN)[1];

export const isBioenergyPathname = (pathname: string) =>
  pathname.includes(BIOENERGY_PATH_SUFFIX);
